export default __webpack_public_path__ + "static/snapchat-b8ef5f711314aeaba8b4e2cf6b821cce.svg";